<template>
<div>
    <v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="Career Map"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="display-1 text-center primary--text font-weight-medium mt-8">JOBS AND SALARIES</div>

        <div class="text-center">
            <v-btn text class="accent--text" @click="$router.push('/map-of-careers')">
                <v-icon small color="accent" left>fa-angle-left</v-icon>
                Back to menu
            </v-btn>
        </div> 

        <v-divider class="mt-3 mb-6"></v-divider>

        <!-- SHOWING COMBO -->
        <!-- <div class="d-flex justify-center mt-1">
            <div style="max-width:320px">
                <v-select
                    v-model="showingCombo"
                    :items="categories"
                    item-text="text"
                    item-value="id"
                    outlined dense
                    append-icon="fa-angle-down accent--text"
                    label="Selecciona">
                </v-select>
            </div>
        </div> -->

        <div v-if="showingCombo=='us' || showingCombo.id=='us'">
            <div class="d-flex align-center justify-center">
                <v-radio-group v-model="kind" row>
                    <v-radio label="All Professions" :value="0"></v-radio>
                    <v-radio label="By State" :value="1"></v-radio>
                    <v-radio label="By Profession" :value="2"></v-radio>
                </v-radio-group>
            </div> 

            <!-- ALL PROFESSION -->
            <template v-if="kind==0">
                <v-card outlined >
                    <div class="d-flex justify-space-between body-2 font-weight-medium white--text primary pa-6">
                        <div>Profession</div>
                    </div>
                    <div :class="{'grey lighten-4': index % 2==1}" v-for="(item, index) in professionsObj" :key="item.id">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div class="body-2 pl-sm-4 text-center text-sm-left mt-2 d-flex">
                                    {{item.name}} 
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="d-flex align-center justify-center justify-sm-end pr-sm-4" :class="{'flex-column':$vuetify.breakpoint.xsOnly}">
                                    <div class="mt-3 mt-sm-0">
                                        <v-btn small depressed class="bMapCareer white--text" @click="goSeeMore(index)">By state</v-btn>
                                        <v-btn small fab text class="ml-2" @click="setActual(item.name)">
                                            <v-icon small color="red" v-if="item.hearted">fa-heart</v-icon>
                                            <v-icon small color="grey" v-else>far fa-heart</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider v-if="index<list.length-1"></v-divider>
                    </div>
                </v-card>
            </template>

            <!-- BY STATE -->
            <template v-if="kind==1">
                <div class="d-flex justify-center">
                    <div style="width:280px">
                        <v-autocomplete
                            v-model="model.state"
                            :items="states"
                            append-icon="fa-angle-down accent--text"
                            outlined dense
                            @change="setListByState"
                            label="Select or type a state">
                        </v-autocomplete>
                    </div>
                </div>

                <v-card outlined v-if="model.state!=''">
                    <div class="d-flex justify-space-between body-2 font-weight-medium white--text primary pa-6">
                        <div>Profession</div>
                        <div class="text-right">Annual mean wage</div>
                    </div>
                    <!-- <div class="pt-3">
                        <div :class="{'grey lighten-4': index % 2==1}" v-for="(item, index) in list" :key="item.id">
                            <div class="d-flex justify-space-between align-center py-4 px-6">
                                <div class="body-2">{{item.profession}}</div>
                                <div class="body-2 black--text">${{item.amount}}</div>
                            </div>
                            <v-divider v-if="index<list.length-1"></v-divider>
                        </div>
                    </div> -->
                    <div :class="{'grey lighten-4': index % 2==1}" v-for="(item, index) in list" :key="item.id">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div class="body-2 pl-sm-4 text-center text-sm-left mt-2 d-flex">
                                    <div class="body-2">{{item.profession}}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="d-flex align-center justify-center justify-sm-end pr-sm-4" :class="{'flex-column':$vuetify.breakpoint.xsOnly}">
                                    <div class="body-2 black--text">${{item.amount}}</div>
                                    <div class="mt-3 mt-sm-0">
                                        <v-btn small fab text class="ml-2" @click="setActual(item.profession)">
                                            <v-icon small color="red" v-if="item.hearted">fa-heart</v-icon>
                                            <v-icon small color="grey" v-else>far fa-heart</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider v-if="index<list.length-1"></v-divider>
                    </div>
                </v-card>
                <div class="d-flex justify-center" v-if="list.length==0">
                    <div>
                        <v-img :src="require('@/assets/careers/map-color.png')" max-width="700"></v-img>
                    </div>
                </div>
            </template>

            <!-- BY PROFESSION -->
            <template v-if="kind==2">
                <div class="d-flex justify-center">
                    <!-- <div> -->
                        <v-autocomplete
                            v-model="model.profession"
                            :items="professions"
                            append-icon="fa-angle-down accent--text"
                            outlined dense
                            @change="setListByProfession"
                            label="Select or type a profession">
                        </v-autocomplete>
                    <!-- </div> -->
                </div>
            
                <v-card outlined v-if="model.profession!=''">
                    <div class="d-flex justify-space-between body-2 font-weight-medium white--text primary pa-6">
                        <div>State</div>
                        <div class="text-right">Annual mean wage</div>
                    </div>
                    <div class="pt-3">
                        <div :class="{'grey lighten-4': index % 2==1}" v-for="(item, index) in list" :key="item.id">
                            <div class="d-flex justify-space-between align-center py-4 px-6">
                                <div class="body-2">{{item.state}}</div>
                                <div class="body-2 black--text">${{item.amount}}</div>
                            </div>
                            <v-divider v-if="index<list.length-1"></v-divider>
                        </div>
                    </div>
                </v-card>
                <v-card flat class="transparent mt-6" v-if="list.length==0">
                    <div class="d-flex align-center justify-center">
                        <v-icon small color="accent" class="mr-3">fa-bell</v-icon>
                        <div class="body-2 bMapCareer--text font-weight-medium">SELECT A PROFESSION</div>
                        <v-icon small color="accent" class="ml-3">fa-bell</v-icon>
                    </div>
                </v-card>
            </template>
         </div>

         <div class="text-center mt-4" v-else>
            Soon you will find it here! <v-icon class="ml-2" color="light-blue">fa-smile-wink</v-icon>
        </div>
    </v-card>

    <DiagTopProf 
        v-if="actual!=null"
        :model="showDiagTop" 
        :item="actual"
        @cancel="closeDiag"
        @changed="setHeart" />
</div>
</template>

<script>
import _ from 'lodash'
import Sign from '@/firebase/sign'
import JobsRefs from '@/services/mapOfCareers/jobsRefs'
import Jobs from '@/services/mapOfCareers/jobs'
import DiagTopProf from '@/components/core/dialogs/DiagTopProf'

export default {
    data: () => ({
        kind: 0,
        states: JobsRefs.ref.states,
        professions: JobsRefs.ref.professions,
        professionsObj: [],
        jobs: Jobs.info,
        model: {
            state: '',
            profession: ''
        },
        list: [],
        fromAll: false,
        showDiagTop: false,
        actual: null,
        showingCombo: 'us',
        categories: [{id:'us', text:'United States'}, {id:'asia', text:'Asia'}, {id:'europe', text:'Europe'}, {id:'rest', text:'Rest of America'}]
    }),
    watch: {
        kind() {
            if (!this.fromAll) {
                this.list = [];
                this.model.state = '';
                this.model.profession = '';
                //this.fromAll = false;
            }
        }
    },
    components: {
        DiagTopProf
    },
    mounted() {
        this.states = _.orderBy(this.states, '', 'asc');
        this.professions = _.sortBy(this.professions);
        this.professions.forEach(dt => {
            this.professionsObj.push({
                name: dt
            })
        });
        this.init();
    },
    methods: {
        init() {
            this.jobs.forEach(dt => {
                dt.amountNumber = parseInt(dt.amount);
            });
            if (this.user.mytop && this.user.mytop.professions) {
                this.setAllHearted(this.user.mytop);
            }
        },
        setListByState() {
            this.list = [];
            this.jobs.forEach(dt => {
                if (dt.state == this.model.state && !this.isRepeated(dt, 'state')) {
                    this.list.push(dt);
                }
            });
            this.list = _.orderBy(this.list, 'amountNumber', 'desc');
            if (this.user.mytop && this.user.mytop.professions) {
                this.setAllHearted(this.user.mytop);
            }
        },
        setListByProfession() {
            this.list = [];
            this.jobs.forEach(dt => {
                if (dt.profession == this.model.profession && !this.isRepeated(dt, 'profession')) {
                    this.list.push(dt);
                }
            });
            this.list = _.orderBy(this.list, 'amountNumber', 'desc');
        },
        isRepeated(str, factor) {
            let tempo = this.list.find(item => {return item == item[factor]});
            if (tempo == undefined) return false;
            return true;
        },
        goSeeMore(index) {
            this.fromAll = true;
            this.model.profession = this.professions[index];
            this.setListByProfession();
            this.kind = 2;
            window.scrollTo(0, 210);
        },
        setActual(str) {
            this.actual = str;
            this.showDiagTop = true;
        },
        closeDiag() {
            this.showDiagTop = false;
            this.actual = null;
        },
        setHeart(e) {
            this.setAllHearted(e);
            this.closeDiag();
            Sign.reInitUser(this.user.uid);
        },
        setAllHearted(owner) {
            this.professionsObj.forEach(dt => {
                if (dt.hearted) {
                    delete dt.hearted;
                }
            });

            this.list.forEach(dt => {
                if (dt.hearted) {
                    delete dt.hearted;
                }
            });

            if (owner.professions.p1) {
                let tempo = this.professionsObj.find(item => {return item.name == owner.professions.p1});
                if (tempo != undefined) {
                    tempo.hearted = true;
                }

                let tem = this.list.find(item => {return item.profession == owner.professions.p1});
                if (tem != undefined) {
                    tem.hearted = true;
                }
            }

            if (owner.professions.p2) {
                let tempo = this.professionsObj.find(item => {return item.name == owner.professions.p2});
                if (tempo != undefined) {
                    tempo.hearted = true;
                }

                let tem = this.list.find(item => {return item.profession == owner.professions.p2});
                if (tem != undefined) {
                    tem.hearted = true;
                }
            }

            if (owner.professions.p3) {
                let tempo = this.professionsObj.find(item => {return item.name == owner.professions.p3});
                if (tempo != undefined) {
                    tempo.hearted = true;
                }

                let tem = this.list.find(item => {return item.profession == owner.professions.p3});
                if (tem != undefined) {
                    tem.hearted = true;
                }
            }
        }
    }
}
</script>